<div class="u-shadow-mini {{ sectionclass }}" style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet_box_specs">
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap"
		>
			<div class="o-stack__cell">
				<h5>{{ sectiontitle }}</h5>
				<span>
					<a
						href="javascript:void(0)"
						class="datatable_download_icon"
						(click)="downloadCSV($event)"
						target="_blank"
						*ngIf="hasData && downloadConfiguration && downloadConfiguration.enableDownload"
					>
						<i class="fa fa-download" aria-hidden="true"></i>
					</a>
				</span>
			</div>
		</div>
		<div class="analytics-portlet-content" style="position: relative; height: 430px">
			<div class="o-stack o-stack--nowrap o-stack--center">
				<div class="donut-chart-container">
					<div #chartElement></div>
					<div
						style="background: #fff; z-index: 10001; position: absolute; top: 0; left: 0; width: 100%; height: 100%"
						*ngIf="!hasData"
					>
						<div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)">
							No Data Available.
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="device-table-widget" *ngIf="hasData">
			<ngx-datatable
				class="datatable"
				[rows]="tableData"
				[columns]="columns"
				[sortType]="'single'"
				[columnMode]="'force'"
				[headerHeight]="50"
				[footerHeight]="50"
				[rowHeight]="'auto'"
				[limit]="10"
				[reorderable]="reorderable"
			>
				<ngx-datatable-footer>
					<ng-template
						ngx-datatable-footer-template
						let-rowCount="rowCount"
						let-pageSize="pageSize"
						let-selectedCount="selectedCount"
						let-curPage="curPage"
						let-offset="offset"
					>
						<div class="datatable-row-center datatable-row-group total-footer">
							<div tabindex="-1" class="sort-active total-label">
								<div class="datatable-body-cell-label">
									<span title="Total">Total</span>
								</div>
							</div>
							<div tabindex="-1" class="datatable-body-cell impressions-footer">
								<div class="datatable-body-cell-label">
									<span>{{ totalObj.impressions | number }}</span>
								</div>
							</div>
							<div
								tabindex="-1"
								class="datatable-body-cell impressions-footer"
								*ngIf="totalObj.household_visits || totalObj.household_visits === 0"
							>
								<div class="datatable-body-cell-label">
									<span>{{ totalObj.household_visits | number }}</span>
								</div>
							</div>
							<div
								tabindex="-1"
								class="datatable-body-cell impressions-footer"
								*ngIf="totalObj.website_attributions || totalObj.website_attributions === 0"
							>
								<div class="datatable-body-cell-label">
									<span>{{ totalObj.website_attributions | number }}</span>
								</div>
							</div>
							<div tabindex="-1" class="datatable-body-cell clicks-footer" *ngIf="totalObj.clicks">
								<div class="datatable-body-cell-label">
									<span>{{ totalObj.clicks | number }}</span>
								</div>
							</div>
							<div tabindex="-1" class="datatable-body-cell clickrate-footer" *ngIf="totalObj.clickRate">
								<div class="datatable-body-cell-label">
									<span>{{ totalObj.clickRate | number : '.0-2' }}%</span>
								</div>
							</div>
							<div tabindex="-1" class="datatable-body-cell clickrate-footer" *ngIf="totalObj.cost">
								<div class="datatable-body-cell-label">
									<span>{{ totalObj.cost | number : '.0-2' }}%</span>
								</div>
							</div>
							<div
								tabindex="-1"
								class="datatable-body-cell clickrate-footer"
								*ngIf="youtubeViewsPermission && totalObj.youtube_verified_imprs >= 0"
							>
								<div class="datatable-body-cell-label">
									<span>{{ totalObj.youtube_verified_imprs | number }}</span>
								</div>
							</div>
							<div
								tabindex="-1"
								class="datatable-body-cell clickrate-footer"
								*ngIf="youtubeViewsPermission && totalObj.youtube_verified_imprs_rate >= 0"
							>
								<div class="datatable-body-cell-label">
									<span>{{ totalObj.youtube_verified_imprs_rate | number : '.0-2' }}%</span>
								</div>
							</div>
						</div>
					</ng-template>
				</ngx-datatable-footer>
			</ngx-datatable>
		</div>
	</div>
</div>
